import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";
import { useNavigate } from "react-router-dom";

const Toolbox = () => {
  const navigate = useNavigate();
  return (
    <nav className="container">
      <div>
        <ToolboxButton
          icon={ToolboxButtonIcon.Back}
          toolbox={true}
          onClick={() => navigate('/dashboard')}
        />
      </div>
      <div></div>
      <div className="printIcon">
        <ToolboxButton
          icon={ToolboxButtonIcon.Chart}
          toolbox={true}
        />
      </div>
    </nav>
  );
};

export default Toolbox;
